import {
  GET_WALLET_STATEMENT_REQUEST,
  GET_WALLET_STATEMENT_SUCCESS,
  GET_WALLET_STATEMENT_FAILURE,
} from "../constants/walletConstant";

const walletStatementInitialState = {
  walletStatement: null,
  walletStatementList: [],
  loading: false,
  error: null,
};

export const walletStatementReducer = (state = walletStatementInitialState, action) => {
  switch (action.type) {
    case GET_WALLET_STATEMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_WALLET_STATEMENT_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case GET_WALLET_STATEMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
